jQuery('.product-cell .product-cell__title').matchHeight();
jQuery('.product-cell .product-cell-desc').matchHeight();

let callbackCart = true;
let printT2 = '';

function refreshHtml(htmlContent) {
    $('.hide--desktop .upsell_dynamic').html(htmlContent);
    $('.upsell_dynamic.hide__mobile').html(htmlContent);
    for(var i = 0; i < $(".upsell_dynamic.hide__mobile .cart-else-item").length; i+=3) {
        $(".upsell_dynamic.hide__mobile .cart-else-item").slice(i, i+3).wrapAll("<div class='col-md-12'></div>");
    }
    $('.upsell_static').css('display','none');
    $('.upsell_recommend').css('display','none');
    $('.upsell_dynamic').css('display','flex');
    $('.upsell_dynamic.hide__mobile').not('.slick-initialized').slick({
        slidesToShow: 1,
        slidesToScroll: 1
    });
    $('.hide--desktop .upsell_dynamic').not('.slick-initialized').slick({
        slidesToShow: 2,
        slidesToScroll: 2
    });
    if ($('.upsell_dynamic').hasClass('slick-initialized')) {
        $('.upsell_dynamic').slick('refresh');
      }
}

// DOMSubtreeModified mutations have deprecated.

// jQuery(document).ready(function ($) {
//     if(callbackCart == true){
//         getLastCartItem();
//     }
//     $('#minicart-block').on('DOMSubtreeModified',function () {
//         if(callbackCart == true){
//             getLastCartItem();
//         }
//     });
// });

// START Testing using new mutations method.

jQuery(document).ready(function ($) {
    if (callbackCart === true) {
        getLastCartItem();
    }
    const targetNode = document.getElementById('minicart-block');
    const config = { childList: true, subtree: true };
    const callback = (mutationsList) => {
        for (const mutation of mutationsList) {
            if (mutation.type === 'childList') {
                if (callbackCart === true) {
                    getLastCartItem();
                }
            }
        }
    };

    const observer = new MutationObserver(callback);
    observer.observe(targetNode, config);
    // observer.disconnect(); // if we want to disconnect the observer
});

// END Testing using new mutations method.

function getLastCartItem() {
    callbackCart = false;
    $.ajax({
        type: 'GET',
        url: '/cart.js',
        dataType: 'json',
        success: function(cart) {
            if (cart.items.length > 0) {
                var lastItem = cart.items[0];
                let fetchRes = fetch(`/products/${lastItem.handle}?view=metafield`);
                fetchRes.then(res => res.text()).then(productsList => {
                    if(productsList == '' ){
                        $('.upsell_dynamic').css('display','none');
                        $('.hide--desktop .upsell_dynamic').html('');
                        $('.upsell_dynamic.hide__mobile').html('');
                        $('.upsell_static').css('display','none');
                        $('.upsell_recommend').css('display','flex');
                        if ($('.upsell_recommend').hasClass('slick-initialized')) {
                            $('.upsell_recommend').slick('refresh');
                          }
                    } else {
                        $('.hide--desktop .upsell_dynamic').html('');
                        $('.upsell_dynamic.hide__mobile').html('');
                        refreshHtml(productsList);
                    }
                });
            } else {
                $('.upsell_dynamic').css('display','none');
                $('.hide--desktop .upsell_dynamic').html('');
                $('.upsell_dynamic.hide__mobile').html('');
                $('.upsell_static').css('display','flex');
                if ($('.upsell_static').hasClass('slick-initialized')) {
                    $('.upsell_static').slick('refresh');
                  }
                $('.upsell_recommend').css('display','none');
            }
            callbackCart = true;
        },
        error: function(XMLHttpRequest, textStatus) {
            console.log('Error:', textStatus);
            callbackCart = true;
        }
    });
}

jQuery(document).ready(function($){
    jQuery.expr[':'].contains = function(a, i, m) {
        return jQuery(a).text().toUpperCase()
            .indexOf(m[3].toUpperCase()) >= 0;
    };
    $('.eabc-recipes-search-wrapper .eabc-recipes-search').on('keyup', function(){
        var searchTerm = $(this).val();
        var category = $('.blog_desc.active').data('type');
        printT2 = '.post-cell[data-type="${category}"]:contains(${searchTerm})';
        if(searchTerm != ''){
            $('.post-cell').hide();
            if(category=='all' || category==''){
                if ($(`.post-cell:contains(${searchTerm})`).length){
                    $(`.post-cell:contains(${searchTerm})`).show();
                }else{
                    $('.noresults-found').show();
                    $('.read-more__button').hide();
                }
            }else{
                if ($(`.post-cell[data-handle="${category}"]:contains(${searchTerm})`).length){
                    $(`.post-cell[data-handle="${category}"]:contains(${searchTerm})`).show();
                }else{
                    $('.noresults-found').show();
                    $('.read-more__button').hide();
                }
            }
        }
        else{
            $('.post-cell').hide();
            if(category=='all' || category==''){
                $(`.post-cell`).show();
                $('.noresults-found').hide();
                $('.read-more__button').show();
            }else{
                $(`.post-cell[data-handle="${category}`).show();
                $('.noresults-found').hide()
                $('.read-more__button').show();
            }
        }
    });

    $('.show-more-swatches-mob').on('click',function(){
      $(this).hide();
      $(this).parent().css('height','auto')
    });

});